// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ar9p","placeholdersHeader":"styles_placeholdersHeader__cFo62","editorStyle":"styles_editorStyle__3sMDS","placeholdersBox":"styles_placeholdersBox__26eEg"};